const messages = {
  pt: {
    translations: {
      all: "Todos",
      code: "Código",
      analysis: "Análise GDS",
      analysis_status: "Status da análise",
      customer: "Cliente",
      selected_analysis: "Análise selecionada",
      selected_analyzes: "Análises selecionadas",
      selected_bom: "BOM selecionado",
      selected_boms: "BOMs selecionadas",
      customers: "Clientes",
      bom: "BOM",
      boms: "BOMs",
      components: "Componentes",
      po_number: "Número da PO",
      supplier: "Fornecedor",
      manufacturers: "Fabricantes",
      status_updated: "Status atualizado",
      purchase_orders: "Ordens de compra",
      upcoming_deliveries: "Próximas Entregas",
      see_all: "Ver todas",
      no_upcoming_deliveries: "Nenhuma entrega futura encontrada.",
      upcoming_deliveries_error: "Não foi possível carregar as próximas entregas.",
      on_hand: "OnHand",
      action: "Ação",
      forecast: "Forecast",
      forecast_type: "Tipo de forecast",
      forecast_flex_dsi_description: "É o que já entra hoje. Base do MRP e da análise de faltas.",
      forecast_net_description: "Demanda pura do cliente. Não roda análise de falta; alimenta as linhas Net do Material Status e a simulação.",
      forecast_customer_required: "Cadastre ou selecione um cliente para importar o forecast.",
      selected_forecast: "Forecast selecionada",
      selected_forecasts: "Forecasts selecionadas",
      forecast_successfully_deleted: "Forecast deletado com sucesso!",
      has_analysis: "Tem análise",
      purchase_order: "Ordem de compra",
      po: "PO",
      is_final_product: "Produto Final?",
      is_in_test: "Em Teste?",
      importation: "Importação",
      description: "Descrição",
      search: "Buscar",
      active: "Ativo",
      created_at: "Criado em",
      modified_at: "Modificado em",
      imported_at: "Data de importação",
      actions: "Ações",
      cancel: "Cancelar",
      save: "Salvar",
      sector: "Setor",
      production_line: "Linha de produção",
      automatic_phase: "Fase automática",
      phase: "Fase",
      new_machine: "Nova Máquina",
      machine: "Máquina",
      process: "Processo",
      proceed: "Prosseguir",
      new: "Novo",
      cost_center: "Centro de custo",
      tag_code: "Código da etiqueta",
      criticality: "Criticidade",
      efficiency: "Eficiência",
      last_maintenance_date: "Data da última manutenção",
      frequency: "Periodicidade",
      utilization_index: "Índice de aproveitamento",
      used_calendar: "Calendário utilizado",
      conference_property: "Propriedade de conferência",
      security_interval: "Intervalo de seguranca",
      unlimited_resource: "Recurso ilimitado",
      area: "Área",
      sequence: "Sequência",
      centesimal_working_hours: "Horas úteis trabalhadas centesimais ",
      saturday_working_hours: "Horas úteis trabalhadas no sábado",
      sunday_working_hours: "Horas úteis trabalhadas no domingo",
      period_working_hours: "Horas úteis do período",
      period_used_hours: "Horas utilizadas no período",
      yield_percentage: "% Rendimento",
      warehouse_consumption: "Armazém de consumo",
      warehouse_description: "Descrição do armazém",
      import_spreadsheets: "Importar Planilhas",
      integration_routines_rfc_sap: "Rotinas de integração (RFC - SAP)",
      sap_import: "Importar SAP",
      rfc_bom_data: "RFC_BOM_DATA",
      rfc_stock_po_data: "RFC_STOCK_PO_DATA",
      run_import: "Executar importação",
      rfc_system: "O sistema realizará a importação das próximas 48 semanas a partir de hoje.",
      execute: "Executar",
      plant: "Planta",
      demands_rfc: "Considerar demandas a partir de",
      select_plant: "Selecione a planta",
      select_date: "Selecione a data",
      select: "Selecione",
      import_modal_title: "Importar Estoque e Ordem de Compra",
      stock_and_po: "Estoque e Ordens de Compra",
      shift: "Turno",
      initial: "Horário inicial",
      final: "Horário final",
      start: "Início",
      product: "Produto",
      unit_measurement: "Unidade de medida",
      abbreviation: "Sigla",
      rows_per_page: "Itens por página",
      product_details: "Detalhes do produto",
      item_code: "Código do item",
      alternative_code: "Código alternativo",
      specific_description: "Descrição específica",
      portuguese_description: "Descrição em português",
      english_description: "Descrição em inglês",
      nickname: "Apelido",
      username: "Usuário",
      password: "Senha",
      recoverPassword: "Redefinir senha",
      confirmPassword: "Confirmar senha",
      email: "E-mail",
      superuser: "Super Usuário",
      product_type: "Tipo do produto",
      raw_material: "Matéria-prima",
      finished_product: "Produto acabado",
      intermediate_product: "Produto intermediário",
      model: "Modelo",
      part_number: "Part Number",
      matl_type: "Tipo do material",
      supplier_part_number_supplier: "Número da peça do fornecedor",
      supplier_part_number_manufacturer: "Número da peça do fabricante",
      level: "Nível",
      part_number_client: "Part number do cliente",
      manufacturer: "Fabricante",
      expiration_date: "Prazo de validade",
      gross_weight: "Peso bruto",
      revision: "Revisão",
      last_revision: "Data da última revisão",
      minimum_grade: "Nota mínima",
      division: "Divisão",
      inventory_frequency: "Periodicidade do inventário",
      base_quantity_structure: "Quantidade base da estrutura",
      decimal_places_production_order: "Tipo de decimais para ordem de produção",
      normal_treatment_without_decimals: "Tratamento normal sem decimais",
      round: "Arredonda",
      increments: "Incrementa",
      truncate_decimal_places: "Trunca as casas decimais",
      model_car: "Modelo do veículo que recebe o produto acabado (BIKE/CAR)",
      direct_or_indirect_appropriation: "Apropriação direta ou indireta",
      direct: "Direta",
      indirect: "Indireta",
      optional_default_group: "Grupo de opcional padrão",
      truncate_or_round: "Trunca ou arredonda",
      truncate: "Trunca",
      block: "Bloqueio de tela",
      enter_mrp: "Entra no MRP?",
      attend_need: "Atende a necessidade",
      notes: "Observação",
      unit_of_measurement: "Unidade de medida",
      unit_measurement_internal: "Unidade de medida interna",
      unit_measurement_entry: "Unidade de medida de entrada",
      second_unit_measurement: "Segunda unidade de medida",
      conversion_factor: "Fator de conversão de unidade de medida",
      conversion_type: "Tipo de conversão da unidade de medida",
      multiplies: "Multiplica",
      divide: "Divide",
      cost_purchase: "Custo/Compra",
      default_supplier: "Fornecedor padrão",
      store_default_supplier: "Loja fornecedor padrão",
      minimum_quantity_order: "Ponto de pedido",
      reference_value_uss: "Valor referência US$",
      sale_price: "Preço de venda",
      last_purchase_currency: "Última moeda de compra",
      last_purchase_value: "Último valor de compra",
      last_purchase: "Data da última compra",
      default_cost_currency: "Moeda do custo standard",
      default_cost: "Custo standart",
      last_calculation_default_cost: "Data do último cálculo do custo padrão",
      fob_cost_currency: "Moeda do custo FOB",
      fob_cost: "Custo FOB",
      last_calculation_fob_cost: "Data do último cálculo do custo FOB",
      delivery_time: "Prazo de entrega",
      delivery_time_type: "Tipo do prazo de entrega (D/M/A)",
      hours: "Horas",
      days: "Dias",
      months: "Meses",
      years: "Anos",
      calculation_delivery_time_formula: "Formula cálculo do prazo",
      tolerance: "Tolerância",
      stock: "Estoque",
      stock_group: "Grupo de estoque",
      maximum_stock: "Estoque máximo",
      security_stock: "Estoque de segurança",
      economic_lot: "Lote econômico",
      minimum_lot: "Lote mínimo",
      packing_quantity: "Quantidade por embalagem",
      security_stock_formula: "Fórmula do estoque de segurança",
      default_warehouse: "Armazem padrão por requisição",
      traceability: "Rastreabilidade",
      product_origin: "Origem do produto",
      national: "Nacional",
      foreign_direct_import: "Estrangeira importação direta",
      foreign_adq_domestic_market: "Estrangeira-Adq no mercado interno",
      foreign: "Estrangeira",
      product_traceability: "Rastreabilidade do produto",
      subbatch_traceability: "Rastreabilidade sublote",
      does_not_use_traceability: "Não usa rastreabilidade",
      batch_traceability: "Rastreabilidade lote",
      default_production_map_operation: "Roteiro de operação padrão",
      copy_quantity_bar_code: "Quantidade cópias para código de barras",
      bar_code: "Código de barras",
      imported_product: "Produto importado",
      purchased_out_state: "Comprado fora do estado",
      family: "É família",
      ghost: "É fantasma",
      controls_addressing: "Controla endereçamento",
      own_third_or_party: "Produção própria ou terceiro",
      own: "Própria",
      third: "Terceiro",
      product_base: "Produto base",
      product_component: "Produto componente",
      loss_index: "Índice de perda",
      initial_validity: "Data inicial da validade",
      final_validity: "Data final da validade",
      process_time: "Tempo do processo",
      quantity_type: "Quantidade fixa/variável",
      optional_group: "Grupo de opcionais",
      item_optional_group: "Item do grupo de opcionais",
      initial_revision: "Revisão inicial do componente",
      final_revision: "Revisão final do componente",
      product_level: "Nível do produto",
      reverse_product_level: "Nível invertido",
      lot_potency: "Potência do lote",
      warehouse: "Armazém de consumo",
      quantity: "Quantidade",
      alternative_use: "Usa alternativo?",
      file_imported: "Arquivo importado",
      import_file: "Importar arquivo",
      import: "Importar",
      user: "Usuário",
      name: "Nome",
      legacy_code: "Código legado",
      group: "Grupo",
      menu: "Menu",
      visible: "Visível",
      permission: "Permissão",
      successfully_updated: "Atualizado com sucesso",
      successfully_registered: "Cadastrado com sucesso",
      successfully_deleted: "Excluído com sucesso",
      all_successfully_deleted: "Todas as análise foram excluidas com sucesso",
      successfully_uploaded: "Importado com sucesso",
      successfully_reset: "Redefinido com sucesso",
      import_started_successfully: "Importação iniciada com sucesso",
      required_field: "O campo é obrigatório.",
      must_be_a_integer_number: "deve ser um número inteiro",
      must_be_a_number: "deve ser um número",
      unique_validation_failure: "falha de validação única",
      must_be_a_positive_number: "deve ser um número positivo",
      invoice_no_date_error: "Invoice não pode ser salva sem data",
      cannot_insert_update_duplicate_key:
        "Não é possível inserir ou atualizar um registro duplicado",
      fixed: "Fixo",
      variable: "Variável",
      invalid_time_format: "Formato de hora inválido",
      invalid_date_format: "Formato de data inválido",
      invalid_number_format: "Formato de número inválido",
      default_moment_locale: "pt-br",
      token_error_redirecting: "Token inválido. Redirecionando...",
      of: "de",
      basic_inputs: "Cadastros básicos",
      product_process: " Produto - Processo",
      invalid_file: "Arquivo inválido",
      enter: "Entrar",
      welcome_home: "Bem vindo ao",
      home: "Início",
      not_found: "Página não encontrada",
      hub_url_unavailable_message: "Não foi possível encontrar o Access Hub. Peça a um administrador para configurar a URL do Hub, ou tente o login local de emergência abaixo, se disponível.",
      invalid_credentials: "Não é possível realizar login com as credenciais fornecidas.",
      exceeds_character_limit: "Limite de caracteres excedido.",
      logout: "Sair",
      session_expired: "Sua sessão expirou.",
      session_expired_title: "Sessão expirada",
      session_expired_message: "Sua sessão expirou. Entre novamente para continuar de onde parou.",
      login_again: "Entrar novamente",
      hub_unavailable_message: "O Access Hub está indisponível no momento.",
      retry: "Tentar novamente",
      local_fallback_login_link: "Entrar com credenciais locais de emergência",
      local_fallback_login_title: "Login local de emergência",
      local_fallback_login_description: "Use suas credenciais locais do PlanMat enquanto o Access Hub está indisponível.",
      local_fallback_login_unavailable: "O login local de emergência não está disponível no momento.",
      confirm: "Confirmar",
      edit: "Editar",
      delete: "Deletar",
      exclude_bom: "Excluir BOM",
      save_form: "Salvar",
      superUser: "Administrador",
      confirm_delete: "Você tem certeza que deseja excluir esse item?",
      confirm_delete_itens: "Você tem certeza que deseja excluir esses itens?",
      analysis_has_child_warning: "Ao excluir esta análise, as análises simuladas serão excluídas.",
      password_not_match: "As senhas não são iguais",
      confirm_recover_password_tittle: "Confirmar redefinição de senha",
      confirm_recover_password_text: "Você tem certeza de que deseja redefinir sua senha?",
      product_line: "Linha de produção",
      planning: "Planejamento",
      simulation: "Simulação",
      simulated_analysis: "Análise simulada",
      is_active: "Ativo",
      is_superuser: "Administrador",
      undefined: "Indefinido",
      module: "Módulo",
      root_description: "Módulo",
      empty_listing: "Nenhum registro encontrado.",
      no_shift: "Nenhum turno encontrado.",
      new_password: "Nova senha",
      confirm_new_password: "Confirmar nova senha",
      security: "Segurança",
      status: "Status",
      inactive: "Inativo",
      codename: "Código",
      redefine_password: "Redefinir senha",
      identity_managed_by_hub: "Usuário, nome e e-mail vêm do Access Hub e são somente leitura aqui.",
      edit_at_access_hub: "Editar no Access Hub",
      user_creation_not_available: "Usuários são criados automaticamente no primeiro login pelo Access Hub.",
      grant_permission: "Conceda todas as permissões.",
      deny_permission: "Negue todas as permissões.",
      codename_or_name: "Nome / Código",
      error_user_selected: "Selecione um usuário para adicionar a permissão.",
      history: "Histórico",
      invalid_edit_group: "Já existe um grupo com este nome.",
      invalid_edit_user: "Já existe um usuário com esses dados.",
      general: "Geral",
      type_process: "Tipo de processo",
      hybrid: "Híbrido",
      available_production_line: "Estações disponíveis para linha de produção:",
      used_production_line: "Utilizados na linha de produção:",
      info_ordination: "Arraste os itens para ordená-los.",
      history_update: "Editado",
      history_create: "Adicionado",
      history_delete: "Excluído",
      is_staff: "É pessoal",
      is_default: "É padrão",
      true: "Sim",
      false: "Não",
      modified_to: "modificado para",
      segment: "Segmento",
      station: "Estação",
      unscheduled_stop: "Parada não programada",
      confirm_type_process: "Confirmar edição",
      confirm_type_process_text:
        "Esta linha de produção possui estação associada, você realmente deseja alterar o tipo de processo? Associações serão perdidas.",
      programmed_shutdown: "Parada programada",
      duration: "Duração",
      type: "Tipo",
      commercial: "Part Number Commercial",
      name_or_commercial: "Part Number Commercial ou Produto",
      start_validity: "Inicio da vigência",
      end_validity: "Fim da vigência",
      search_name: "Buscar nome",
      search_programmed: "Buscar parada programada",
      validity_start_date: "Início da vigência",
      validity_end_date: "Fim da vigência",
      start_time: "Hora de início",
      end_time: "Hora de término",
      error_required_field: "Verifique se todos os campos obrigatórios foram preenchidos.",
      invalid_group: "Já existe um grupo com este nome.",
      replanning_reason: "Motivo de Replanejamento",
      reason: "Motivo",
      cause: "Motivo Padrão",
      yes: "Sim",
      no: "Não",
      the_record_already_exists: "O registro já existe",
      loading: "Carregando",
      invalid_format: "Formato inválido",
      order: "Ordem",
      search_shift: "Buscar turno",
      workday: "Jornada de trabalho",
      length: "Duração",
      error_programmed_selected: "Selecione uma parada programada para associar ao turno.",
      module_options: "O que você deseja fazer?",
      production_capacity: "Capacidade de produção",
      basic: "Básico",
      reports: "Relatórios",
      settings: "Configurações",
      access_control: "Controle de acesso",
      invalid_email: "Você deve inserir um e-mail válido.",
      registrations: "Cadastros",
      demand: "Demanda",
      production_planning: "Planejamento de produção",
      replanning_history: "Histórico de replanejamento",
      smt_default_time: "Tempo padrão de SMT",
      manual_default_time: "Tempo padrão manual",
      scheduled_stop: "Paradas programadas",
      reason_replanning: "Motivo de replanejamento",
      production_ramp: "Rampa de produção",
      calendar_event_type: "Tipo de evento do calendário",
      calendar: "Calendário",
      marker: "Marcador",
      reason_replanning_report: "Motivos de replanejamento",
      production_line_usage: "Utilização de linhas de produção",
      realized_vs_planned: "Realizado vs planejado",
      preferences: "Preferências",
      expression_builder: "Construtor de expressões",
      headcount: "Quantidade de pessoas",
      stops: "Paradas",
      line_configuration: "Configuração de linha",
      default: "Padrão",
      color: "Cor",
      search_description: "Buscar descrição",
      useful_day: "Dia útil",
      day_off: "Dia de folga",
      pn_commercial: "PN Comercial",
      is_top_bottom: "Top-Bottom",
      component: "Componente",
      sides: "Lados",
      add: "Adicionar",
      production_ramp_settings: "Configurações da rampa",
      npi: "NPI",
      side: "Lado",
      version: "Versão",
      versions: "Versões dos sistemas",
      production_order: "Ordem de produção",
      reference_date: "Data de referência",
      font_color: "Cor da fonte",
      production_order_peripheral: "Ordem de produção dos periféricos",
      lines: "Linhas",
      production_ramp_day: "Dia ",
      validate_production_lines: "As linhas de produção devem conter as mesmas configurações",
      duplicate: "Duplicar",
      default_time_seconds: "Tempo padrão",
      people_quantity: "Quantidade de pessoas",
      capacity: "Capacidade",
      default_expression: "Expressão padrão:",
      expression: "Expressão",
      initial_date: "Data inicial",
      final_date: "Data final",
      available: "Disponível",
      planned: "Planejado",
      in_production: "Em produção",
      finished: "Finalizado",
      january: "Janeiro",
      february: "Fevereiro",
      march: "Março",
      april: "Abril",
      may: "Maio",
      june: "Junho",
      july: "Julho",
      august: "Agosto",
      september: "Setembro",
      october: "Outubro",
      november: "Novembro",
      december: "Dezembro",
      message_home: "O Plan-Mat é um sistema de planejamento de compra de materiais.",
      save_plus: "Salvar +",
      close: "Fechar",
      clear: "Limpar",
      open: "Abrir",
      month: "Mês",
      year: "Ano",
      event: "Evento",
      start_date: "Data inicial",
      end_date: "Data final",
      validate_end_time: "Este tempo deve ser maior",
      validate_event_create: "Só é permitido criar um evento após a data atual",
      available_time: "Tempo disponível",
      return_value: "Valor de retorno",
      default_time: "Tempo padrão",
      assemble_expression: "Monte a expressão:",
      set_default_expression: "Definir como expressão padrão",
      AVAILABLE_TIME: "TEMPO DISPONÍVEL",
      DEFAULT_TIME: "TEMPO PADRÃO",
      PEOPLE_QUANTITY: "QUANTIDADE DE PESSOAS",
      CAPACITY: "VOLUME",
      volume: "Volume",
      day: "Dia",
      line: "Linha",
      duplicate_version: "Duplicar versão",
      delete_version: "Deletar versão",
      change_final_version: "Alterar para versão final",
      duplicate_version_successfully: "Versão duplicada com sucesso",
      confirm_make_version_final: "Deseja realmente tornar a versão ($description) como final?",
      to_plan: "Planejar",
      sunday: "Domingo",
      monday: "Segunda-Feira",
      tuesday: "Terça-Feira",
      wednesday: "Quarta-Feira",
      thursday: "Quinta-Feira",
      friday: "Sexta-Feira",
      saturday: "Sábado",
      new_marker: "Novo marcador",
      peripheral: "Periféricos",
      interrupt_demand: "Interromper demanda",
      markers: "Marcadores",
      remove_planning_message: "Deseja remover o planejamento?",
      can_not_edit_planning_with_final_version:
        "Não é possível fazer alteração em uma versão de produção.Altere uma versão duplicada e depois publique",
      production_line_top: "Linha de produção TOP",
      production_line_bot: "Linha de produção BOTTON",
      demand_total: "Total da demanda",
      shift_to_start: "Turno para inicio",
      line_setup_stop: "Parada de setup de linha",
      different_line: "Fases A e B em linhas diferentes",
      shifts: "Turnos",
      production_line_backend: "Linha de produção backend",
      associate_shift: "Associar turno",
      no_associated_shift: "Nenhum turno associado",
      value_day_one: "Valor do dia 1",
      value_day_two: "Valor do dia 2",
      value_day_three: "Valor do dia 3",
      value_day_four: "Valor do dia 4",
      value_day_five: "Valor do dia 5",
      value_day_six: "Valor do dia 6",
      value_day_seven: "Valor do dia 7",
      production_line_required: "Selecione ao menos uma linha de produção",
      info_demand: "Informação da demanda",
      edit_demand: "Editar demanda",
      history_month: "Histórico no mês",
      balance: "Saldo",
      planned_quantity: "Planejado",
      move_balance: "Mover saldo",
      bone_pile: "Defeito",
      scrap: "Sucata",
      realized: "Realizado",
      finalize_demand: "Finalizar demanda",
      info_finalize_demand: "Deseja finalizar a demanda?",
      finalize: "Finalizar",
      smt_configuration: "Sem configuração de tempo SMT",
      manual_configuration: "Sem configuração de tempo Manual",
      unknown_error: "Oops... ocorreu algo inesperado!",
      new_simulation: "Nova simulação",
      new_version: "Nova versão",
      all_rights_reserved: "2025 Foxconn. Todos os direitos reservados.",
      developed_by: "Desenvolvido por",
      edit_planning: "Editar planejamento",
      smt_warnning: "Tempo SMT",
      manual_warnning: "Tempo Manual",
      valid_quantity: "Quantidade não pode ultrapassar o valor da demanda",
      anticipate_planning: "Antecipar próximos planejamentos",
      replanning_amount: "Quantidade de replanejamento",
      date: "Data",
      must_be_bigger_equal_than_start_date: "Precisa ser maior ou igual a data inicial",
      must_be_less_equal_than_final_date: "Precisa ser menor ou igual a data final",
      must_be_bigger_than_start_date: "Precisa ser maior que a data inicial",
      must_be_less_than_final_date: "Precisa ser menor que a data final",
      must_be_bigger_than_start_time: "Precisa ser maior que a hora inicial",
      must_be_less_than_final_time: "Precisa ser menor que a hora final",
      line_setup: "Setup de linha",
      no_records_found: "Nenhum registro encontrado",
      demand_used_hours: "Horas usadas por demanda",
      group_by: "Agrupado por",
      consolidated: "Consolidado",
      detailed: "Detalhado",
      import_material_transit: "Importar materiais em trânsito",
      product_description: "Descrição do produto",
      delivery_date: "Data de chegada",
      result: "Resultado",
      side_a: "Lado A",
      side_b: "Lado B",
      max_qtd: "Quantidade máx. ",
      product_model: "Modelo do produto",
      title_event: "evento",
      attention: "Atenção",
      exists_planning: "Já existe planejamento neste período, deseja continuar e replanejar?",
      add_delay: "Preencha para retardar o inicio da linha de produção do backend.",
      delivery: "Entrega",
      planning_by_delivery: "Planejamento por entrega",
      no_planned: "Não planejado",
      input: "Insumo",
      create_demand: "Criar demanda",
      simulation_options: "Opções da simulação",
      max_value: "O campo não pode ser maior que ",
      min_value: "O campo não pode ser menor que ",
      invalid_quantity: "Quantidade insulficiente para criar demanda",
      value: "Valor",
      MAIL_HOST: "E-mail host",
      MAIL_PORT: "E-mail porta",
      MAIL_SENDER: "Remetente de email",
      MAIL_PASSWORD: "Senha do e-mail",
      MAIL_USE_TLS: "Uso de TLS no e-mail",
      MAIL_USE_SSL: "Uso de SSL no e-mail",
      DEMAND_DAYS_BEFORE_VALIDATE: "Dias antes de validar demandas",
      EMAILS_TO_ALERT: "E-mails para alertar",
      PRODUCTION_PLAN_XLS_PATH: "Local para gerar o arquivo xls do planejamento",
      notifications: "Notificações",
      verify_demand: "Verificar demanda",
      production_line_manual: "Linha de produção manual",
      production_line_smt: "Linha de produção SMT",
      next: "Próximo",
      previous: "Anterior",
      select_demand: "Selecionar demanda",
      adjust_variables: "Ajustar variáveis",
      define_period_and_shifts: "Definir turnos e período",
      top_bottom_different_line: "Top / Bottom em linhas diferentes",
      planned_qty: "Qtd. planejada",
      head_count: "Head count",
      production_time: "Tempo de produção",
      ramp: "Rampa",
      input_a_value: "Digite o valor",
      greater_than_equal_0: "O campo deve ser maior ou igual a 0",
      greater_than_equal_1: "O campo deve ser maior ou igual a 1",
      less_than_equal_1000: "O campo deve ser menor que 1000",
      generate_demand: "Gerar demandas",
      line_setting: "Configuração de linha",
      smt: "SMT",
      manual: "Manual",
      aligned: "Alinhado",
      create: "Criar",
      delete_simulation: "Limpar planejamentos futuros",
      simulation_result: "Resultado da simulação",
      sync: "Sincronizar",
      total_forecast: "Total forecast",
      delayed: "Atrasado",
      total_simulations: "Total de simulações",
      plannings_removed: "Planejamentos removidos",
      optimization_progress: "Progresso da otimização",
      optimization_started: "Otimização iniciada",
      optimization_finalized: "Otimização finalizada",
      downtime_reason: "Motivo de parada",
      downtime: "Parada",
      scheduled: "Programada",
      unscheduled: "Não programada",
      downtime_ranking: "Ranking de paradas",
      reason_qty: "Quantidade",
      downtime_summary_by_quantity_report: "Paradas por tempo e quantidade",
      downtime_summary_by_available_time_report: "Paradas por tempo disponível",
      downtime_by_year: "Paradas por ano",
      downtime_by_month: "Paradas por mês",
      downtime_by_week: "Paradas por semana",
      downtime_by_day: "Paradas por dia",
      report_by_available_time: "Relatório por tempo disponível",
      time: "Tempo",
      report_type: "Tipo de relatório",
      planned_quantity_required: "Quantidade planejada é obrigatória",
      capacity_required: "Capacidade é obrigatória",
      import_production: "Importar produção",
      verify_planning: "Verificar planejamento",
      produced_quantity: "Quantidade produzida",
      week: "Semana",
      weeks: "Semanas",
      qty: "Quantidade",
      product_name: "Produto",
      segment_name: "Segmento",
      realized_and_planned_by_year: "Realizado vs planejado por ano",
      realized_and_planned_by_month: "Realizado vs planejado por mês",
      realized_and_planned_by_week: "Realizado vs planejado por semana",
      realized_and_planned_by_day: "Realizado vs planejado por dia",
      production_import_successful: "Produção importada com sucesso!",
      nothing_to_import: "Nada para importar",
      start_week: "Semana inicial",
      end_week: "Semana final",
      must_be_bigger_equal_than_start_week: "Precisa se maior que a semana inicial",
      select_by: "Selecionar por",
      oee_month_goal: "Meta mensal OEE",
      oee_year_goal: "Meta anual OEE",
      goal: "Meta",
      oee: "OEE",
      monthly: "Mensal",
      weekly: "Semanal",
      oee_one: "O.E.E.1",
      monthly_oee: "Mensal OEE1",
      year_oee: "Anual OEE1",
      month_target: "Meta mensal",
      year_target: "Meta anual",
      dashboard: "Dashboard",
      ai_demand_forecast: "Previsão de demanda por IA",
      dashboard_oee: "Dashboard OEE",
      period: "Período",
      achieved: "Realizado",
      percentage: "Porcentagem",
      backlog: "Diferença",
      current_year_realized: "Realizado ano atual",
      current_year_backlog: "Diferença ano atual",
      current_month_realized: "Realizado mês atual",
      current_week_realized: "Realizado semana atual",
      ft_test_buffer: "FTTest Buffer",
      wip_volume: "Wip Volume",
      import_line_schedule: "Importar programação linha",
      serial_number: "Serial number",
      rev: "REV",
      bios_rev: "BIOS REV",
      model_name: "Modelo",
      group_name: "Grupo",
      next_station: "Próximo posto",
      last_log: "Data registro",
      working_time: "Tempo de trabalho",
      emp_no: "EMP NO",
      rota: "ROTA",
      total: "Total",
      line_schedule: "Programação de linha",
      hour: "Hora",
      today: "Hoje",
      production_order_demand: "Ordens de produção da demanda",
      buffer_chart: "Buffer Chart",
      delivery_file: "Arquivo de entrega",
      columns: "Colunas",
      released_forecast: "Released forecast",
      total_backlog: "Total Backlog",
      slc_on_hand: "SLC On-Hand (LT=0)",
      factory_on_hand: "Factory On-Hand",
      projected_inventory: "Inventário projetado",
      projected_dsi: "Projected DSI",
      local_balance: "Inventário Local",
      update_with_planned: "Atualizar com o planejado",
      active_line_count: "Linhas ativas",
      active_line_shift: "Linhas ativas por turno",
      safety_stock_ok: "Estoque de segurança ok",
      excess_stock: "Estoque em excesso",
      stock_on_alert: "Estoque em alerta",
      critical_stock: "Estoque crítico",
      active_people_count: "Pessoas ativas",
      active_people_line: "Pessoas ativas por linha",
      upph: "UPPH",
      uph: "UPH",
      upph_production_line: "UPPH Linha de produção",
      send_final_version_planning: "Enviar versão final",
      successfully_send_planning: "Planejamento enviado com sucesso",
      final_version_planning: "Planejamento versão final",
      select_an_item_below: "Selecione um item ao lado",
      more_options: "Mais opções",
      invalid_emails: "Insira e-mails válidos separados por ponto e vírgula.",
      last_updated: "Última atualização",
      next_updated: "Próxima atualização",
      automatic: "Automático",
      manual_or_smt: "Manual ou SMT",
      urgent_planning: "Planejamento urgente",
      initial_quantity: "Quantidade inicial",
      yearly_chart: "Gráfico anual",
      monthly_chart: "Gráfico mensal",
      weekly_chart: "Gráfico semanal",
      daily_chart: "Gráfico diário",
      info_search_reports: "Os valores exibidos correspondem ao período selecionado",
      bom_number: "Número da BOM",
      code_bom: "Código da BOM",
      failed_to_retrieve_customers:
        "Falha ao buscar a lista de clientes. Por favor, tente novamente.",
      file_must_be_selected: "Você deve selecionar um arquivo antes de prosseguir.",
      file_uploaded_successfully_one: "Arquivo enviado com sucesso!",
      file_uploaded_successfully_other: "Arquivos enviados com sucesso!",
      failed_to_upload_file: "Falha ao enviar o arquivo. Por favor, tente novamente.",
      drag_and_drop_file: "Arraste e solte um arquivo .xlsx aqui ou clique em importar.",
      forecast_number: "Número do Forecast",
      import_bom: "Importar BOM",
      import_forecast: "Importar Forecast",
      upload_file: "Importe seu arquivo de ($type)",
      finished_good: "Produto Acabado",
      creation_date: "Data de criação",
      created_by: "Criado por",
      waiting_analysis: "Aguardando",
      processing_analysis_col: "Processando",
      finalizing_analysis: "Finalizando",
      concluded_analysis: "Concluída",
      calculation_error_analysis: "Erro no cálculo",
      save_error_analysis: "Erro ao salvar",
      analysis_type_analysis: "Análise",
      simulation_type_analysis: "Simulação",
      simulation_tooltip: "Simulação da análise Id: {{id}}",
      waiting_analysis_tooltip:
        "A análise foi solicitada e está na fila para iniciar o processamento.",
      processing_analysis_tooltip:
        "A análise está calculando os resultados. Aguarde a conclusão antes de consultar os detalhes.",
      finalizing_analysis_tooltip:
        "Os resultados já foram calculados e estão sendo preparados para liberação. Ainda não é possível abrir detalhes ou exportar.",
      concluded_analysis_tooltip:
        "A análise foi processada e os resultados estão disponíveis para consulta e exportação.",
      calculation_error_analysis_tooltip:
        "A análise não foi concluída porque ocorreu uma falha durante o processamento dos dados.",
      save_error_analysis_tooltip:
        "Os resultados foram calculados, mas ocorreu uma falha ao salvar os dados. Tente processar novamente ou acione o suporte.",
      import_date: "Data de importação",
      file_name: "Nome do arquivo",
      document: "Documento",
      material: "Material",
      bom_component: "Componente de BOM",
      use_quantity: "Qtde. de uso",
      bom_not_imported: "BOM não importada no sistema.",
      create_new_analysis: "Criar nova análise",
      processing: "Processamento",
      fully_completed: "Finalizada",
      analysis_fully_completed_tooltip:
        "Análise totalmente finalizada (cálculo e persistência concluídos)",
      analysis_not_fully_completed_tooltip: "Análise ainda não finalizada completamente",
      new_analysis: "Nova análise",
      priority: "Prioridade",
      select_customer: "Selecione o cliente:",
      processs_analysis: "Processar análise",
      select_customer_error: "Selecione um cliente para prosseguir.",
      select_forecast: "Selecione o Forecast:",
      select_forecast_error: "Selecione um forecast para prosseguir.",
      organize_by_priority: "Organize por prioridade:",
      change_priority: "Click, segure e arraste os itens na lista para mudar a prioridade.",
      order_button: "Arraste as linhas ou use os botões para reordenar",
      priority_empty: "Não há itens para organizar por prioridade.",
      running_analysis: "Processando a análise.",
      calc_available_demand: "Calculando disponibilidade e demanda...",
      process_information: "Você pode acessar outros módulos do sistema enquanto aguarda.",

      send: "Enviar",
      file_must_follow_template: "O arquivo deve seguir o padrão do modelo XLSX.",
      download_template: {
        text: "Baixe o modelo ",
        link: "aqui.",
      },
      models: "Modelos",
      transit: "Trânsito",
      in_stock: "Em estoque",
      in_transit: "Em Trânsito",
      substitutes: "Substitui",
      final_products: "Modelos",
      unit_price: "Preço unit.",
      unit_price_table: "Valor Unit.",
      total_value_table: "Valor Total",
      stock_onhand: "Estoque (Onhand)",
      stock_value: "Valor em estoque",
      balance_value: "Valor do saldo",
      usage_quantity: "Qtd de uso",
      model_apportionment: "Rateio por modelo",
      proportional_usage_sum: "proporcional à qtd de uso (soma dos usos: {{total}})",
      unit_short: "un",
      export_analysis: "Exportar .xlsx",
      export_filtered_analysis: "Exportar filtrado",
      export_complete_analysis: "Exportar completo",
      material_status: "Material Status",
      material_status_not_generated_tooltip:
        "Esta análise ainda não possui Material Status gerado. Conclua o GDS e clique em Gerar Material Status.",
      generate_material_status: "Gerar Material Status",
      view_material_status: "Ver Material Status",
      open_material_status: "Abrir Material Status",
      material_status_generating: "Gerando…",
      material_status_generation_failed: "Falha ao gerar",
      material_status_retry: "Tentar novamente",
      material_status_subtitle:
        "Esta ação congelará os dados da análise atual em um Material Status.",
      material_status_current_analysis: "Análise atual",
      material_status_analysis_date: "Data da análise",
      material_status_horizon: "Horizonte",
      material_status_weeks: "{{count}} semanas",
      material_status_boms_included: "BOMs incluídas",
      material_status_available_data: "Dados que serão disponibilizados",
      material_status_models_boards: "Modelos/Placas",
      material_status_gds_items: "Itens (GDS)",
      material_status_identification: "Identificação e rastreabilidade",
      material_status_history_intro: "Será registrado um histórico com:",
      material_status_generation_date: "Data e hora da geração",
      material_status_responsible_user: "Usuário responsável",
      material_status_linked_analysis: "Análise vinculada",
      material_status_models_items_quantity: "Quantidade de modelos/itens",
      material_status_models_items_value: "{{models}} modelos / {{items}} itens",
      material_status_preview: "Prévia da geração",
      material_status_models_boards_quantity: "Quantidade de modelos/placas",
      material_status_status: "Status",
      material_status_ready: "Pronto para gerar",
      material_status_data_unavailable: "Não disponível",
      material_status_static_notice:
        "Os dados publicados refletirão exatamente o estado desta análise no momento da geração.",
      material_status_confirm: "Confirmar geração",
      material_status_analysis_unavailable:
        "A geração estará disponível quando a análise estiver totalmente concluída.",
      material_status_integration_unavailable:
        "Esta análise ainda não está pronta para geração.",
      material_status_not_ready:
        "A geração não está disponível para esta análise.",
      material_status_summary_error:
        "Não foi possível carregar a prévia da geração.",
      material_status_generation_error:
        "Não foi possível gerar o Material Status.",
      material_status_already_generated:
        "Esta análise já possui um Material Status gerado.",
      material_status_not_generated: "Material Status não gerado",
      material_status_empty_description:
        "Gere o Material Status quando desejar congelar os dados desta análise.",
      material_status_generation_success: "Material Status gerado com sucesso.",
      material_status_generated_metadata: "{{name}} · UUID {{uuid}}",
      material_status_generated_tooltip: "Material Status gerado",
      material_status_generated_at_tooltip: "Material Status gerado em {{- date}}",
      bom_model: "Modelo da BOM",
      item: "Item",
      purchase_priority: "Prioridade de compra",
      usage_priority: "Prioridade de uso",
      phantom: "Phantom",
      is_imperfect: "Imperfeito",
      perfect: "Perfeito",
      legend: "Legenda",
      prime: "Primário",
      alternative: "Alternativo",
      missing_bom_detected: "BOMs ausentes detectadas",
      missing_bom_text:
        "Existem modelos neste Forecast sem BOMs importadas no sistema. Deseja prosseguir com a análise?",
      proceed_regardless: "Continuar mesmo assim",
      import_history: "Histórico de importações",
      import_file_type_not_accepted: "Tipo de arquivo não aceito. Por favor, use .xlsx ou .xls",
      analysis_processing: "Processamento da Análise",
      in_processing: "Em andamento",
      concluded: "Concluído",
      execution_time: "Tempo de execução",
      processing_start_time: "Data/Hora início",
      processing_end_time: "Data/Hora fim",
      cancel_processing: "Cancelar processamento",
      download_log: "Baixar log",
      open_gds: "Abrir GDS",
      error: "Erro",
      completed: "Completado",
      canceled: "Cancelado",
      waiting: "Aguardando",
      processing_analysis: "Em andamento",
      import_in_progress: "Importação em andamento",
      import_failed: "Falha na Importação",
      waiting_in_queue: "Aguardando na fila...",
      import_completed_reloading: "Importação concluída! Atualizando página...",
      processing_file: "Processando arquivo...",
      processing_import: "Processando",
      rows: "linhas",
      file_selected: "Arquivo selecionado",
      files_selected: "arquivos selecionados",
      no_file_selected: "Nenhum arquivo selecionado.",
      all_files_failed_to_import: "Todos os arquivos falharam ao importar.",
      files_failed_to_import: "Falha ao importar {{failed}} de {{total}} arquivos.",
      here: "aqui",
      time_remaining: "Tempo estimado restante:",
      minute: "minuto",
      minutes: "minutos",
      and: "e",
      error_processing: "Erro ao processar a análise.",
      download_message: "Você pode baixar o log técnico para mais detalhes.",
      estimating: "Estimando",
      analysis_details: "Ver detalhes da análise",
      delete_analysis: "Excluir registro",
      delete_item: "Excluir",
      filter: "Filtrar",
      apply: "Aplicar",
      select_all: "Selecionar tudo",
      selected_models: "Selecionar modelos",
      finished_goods: "Finished goods",
      move_top: "Mover para o topo",
      subtotal: "Subtotal",
      unit: "Unid.",
      estimated_time_delivery: "ETD",
      see_details: "Ver detalhes",
      download: "Baixar",
      see_queue: "Ver fila",
      see_error: "Ver error",
      follow_execution: "Acompanhar",
      analysis_is_running: "Análise em processamento",
      analysis_finished_successfully: "Análise concluída com sucesso",
      analysis_created_successfully: "Analysis created successfully",
      analysis_canceled: "Análise cancelada",
      error_processing_analysis: "Erro ao processar análise",
      analysis_waiting_start: "Análise aguardando início",
      analysis_waiting_in_queue: "Aguardando na fila para realizar a análise",
      no_notifications: "Sem notificações",
      unit_measure: "Unid. de medida",
      total_to_go: "Total To Go",
      no_in_transit: "Nenhum item em trânsito.",
      cell_data_processing:
        "O extrato detalhado ainda está sendo salvo no sistema. Aguarde alguns instantes para visualizar as informações completas.",
      select_period: "Período:",
      bom_quantity: "Quantidade de BOM",
      copy: "Copiar",
      copied: "Copiado",
      system_data: "Dados de sistema",
      update_data: "Atualizar dados",
      manual_edit: "Edição manual",
      bom_priority: "Prioridade de BOM",
      stock_and_transit: "Estoque e Trânsito",
      edit_manually: "Editar Manualmente",
      duplicate_analysis: "Duplicar Análise",
      copy_analysis: "Cópia",
      simulate_gds: "Simular GDS",
      reset: "Redefinir",
      reprocess_analysis: "Reprocessar Análise",
      reset_data: "Redefinir dados",
      confirm_reset: "Você tem certeza que deseja redefinir os dados?",
      original_value: "Valor original",
      original: "Original",
      invoice: "Invoice",
      invoice_search_placeholder: "Separe múltiplas invoices com ;",
      invoice_not_found: "Invoice não encontrada",
      cancel_analysis_simulation: {
        discard_simulation: "Descartar simulação",
        message: "Tem certeza de que deseja cancelar a criação desta simulação?",
        description: "As alterações feitas até aqui serão perdidas.",
        mantain_simulation: "Manter simulação",
        cancel_simulation: "Cancelar simulação",
      },

      analysis_selector: {
        indicators_from: "Indicadores da análise:",
        select_analysis: "Selecionar análise",
        open_analysis: "Abrir esta análise",
        search_placeholder: "Buscar por número, descrição ou cliente",
        completed_analyses: "Análises concluídas",
        most_recent: "mais recente",
        empty: "Nenhuma análise encontrada.",
      },
      coverage_indicators: "Indicadores de cobertura",
      coverage_critical: "Cobertura Crítica",
      coverage_partial: "Cobertura de Atenção",
      coverage_total: "Excesso de materiais",
      items_less_coverage: "Itens com até 4 semanas de cobertura.",
      items_partial_coverage: "Itens com cobertura entre 5 e 8 semanas.",
      items_full_coverage: "Itens com excesso após cobertura total.",
      configurations: "Configurações",
      continuous_forecasting: "Previsão continua e detecção de outliners (IC95%)",
      forecast_long_run: "Previsão de longo prazo",
      high_demand: "Demanda em alta nos últimos 5 meses.",
      deviations_anomalies: "Desvios/Anomalias",
      occurrences: "Ocorrências",
      out_or_in_standard: "Consumo {{type}} do padrão nos últimos 5 meses.",
      confidence_interval: "Intervalo de confiança",
      ic: "IC 95%",
      low_high_demand: "Demanda {{type}} nos últimos 5 meses.",
      low_high_trend: "Tendência {{type}} nos últimos 5 meses.",
      dashboard_page: {
        ic_trust: "IC 95% (Intervalo de confiança)",
        ic_forecast: "IC 95% (Previsão)",
        history: "Forecast consolidado",
        predicted: "Forecast previsto IA",
        out_of_standard: "Fora do Padrão",
        trend: "Tendência",
        forecast: "Forecast previsto Dell",
        high: "alta",
        low: "baixa",
        neutral: "neutra",
        standard: "dentro",
        out_of_standard_history: "fora",
      },
      expired_date: "Data expirada",
      material_in_transit: "Material em trânsito",
      waiting_invoice: "Aguardando fatura",
      delete_waiting_invoice_items: "Excluir itens aguardando fatura",
      confirm_delete_waiting_invoice: "Deseja remover todos os itens com status Aguardando fatura do cenário da simulação?",
      waiting_invoice_deleted_successfully: "Itens aguardando fatura removidos com sucesso.",
      purchase_orders_by_status: "Ordens de Compra por Status",
      orders_total_count: "{{total}} ordens no total",
      orders: "ordens",
      of_total: "do total",
      view_all: "Ver todas",
      materials_demands: "Itens e Demanda",
      gds_result: "Resultado GDS",
      update_prices: "Atualizar preços",
      updating_prices: "Atualizando preços...",
      price_last_updated: "Preços atualizados pela última vez em {{date}}",
      update_sap_prices_confirmation:
        "Deseja iniciar a atualização dos preços de materiais e demandas para esta análise?",
      price_update_started: "Atualização de preços iniciada.",
      price_update_completed: "Preços atualizados com sucesso.",
      price_update_failed: "A atualização de preços SAP falhou.",
      price_update_already_running: "Já existe uma atualização de preços em andamento.",
      price_update_start_failed: "Não foi possível iniciar a atualização de preços.",
      select_analysis_to_update_prices: "Selecione uma análise para atualizar os preços.",
      material_type: "Tipo do Material",
      metrics_items_with_demand: "Itens com demanda",
      metrics_critical: "Cobertura crítica: até 4 semanas",
      metrics_attention: "Cobertura com atenção: 5 a 8 semanas",
      metrics_stable: "Cobertura saudável: acima de 8 semanas",
      metrics_excess: "Itens em excesso",
      metrics_unclassified: "Sem cobertura válida",
      coverage: "Cobertura",
      excess: "Em excesso",
      balance_filter: "Saldo",
      balance_excess: "Em excesso",
      balance_shortage: "Em falta",
      predicted_demand: "Demanda prevista",
      coverage_low: "Crítica, < 50%",
      coverage_insufficient: "Parcial, 50% a 99%",
      coverage_complete: "Completa, 100%",
      coverage_critical_week: "Crítico: até 4 semanas",
      coverage_attention: "Atenção: 5 a 8 semanas",
      coverage_stable: "Saudável: acima de 8 semanas",
      waiting_invoice_label: "Aguardando Fatura",
      shortage: "Shortage",
      copy_failed: "Falha ao copiar",
      model_quantity: "Quantidade do modelo",
      analysis_not_found: "Análise não encontrada",
      invalid_api_response: "Resposta inválida da API",
      export_already_created_downloading: "Exportação já criada, baixando arquivo...",
      error_downloading_file_try_again: "Erro ao baixar arquivo. Tente novamente.",
      export_error: "Erro na exportação",
      export_analysis_started: "Exportação da análise iniciada",
      export_analysis_completed: "Exportação da análise concluída",
      export_analysis_started_success: "A exportação da análise foi iniciada com sucesso.",
      export_analysis_completed_success: "A exportação da análise foi concluída com sucesso.",
      export_started_notification:
        "Exportação iniciada. Você será notificado quando estiver pronta.",
      export_disabled_persistence_pending:
        "A exportação estará disponivel assim que todos os seus dados forem salvos. Você será notificado quando estiver pronta.",
      export_no_data_available:
        "Não foi possível exportar a planilha. Não há dados disponíveis para exportação. Por favor, verifique os filtros ou realize uma nova análise para gerar conteúdo.",
      selected_records: "Registros selecionados",
      selected_record: "Registro selecionado",
      delete_import_history: "Excluir histórico de importações",
      error_fetch_data: "Erro ao buscar os dados",
      error_deleting_boms: "Erro ao deletar BOMs",
      some_boms_not_deleted: "Algumas BOMs não foram deletadas",
      boms_successfully_deleted: "BOMs deletadas com sucesso",
      cannot_delete_bom_with_active_analysis:
        "Não é possível excluir BOMs que participam de análises em aberto",
      import_data: "Importar dados",
      select_source_data: "Selecione a fonte de dados:",
      files_xls: "Arquivos .xls",
      sap_data: "Dados do SAP",
      partially_updated: "Atualizado Parcialmente",
      updated: "Atualizado",
      operation: "Operação",
      homolog_local: "Ambiente de Homologação",
      development_local: "Ambiente de Desenvolvimento",
      reprocess_failures: "Reprocessar Falhas",
      updated_boms: "BOMs Atualizadas",
      failed_boms: "BOMs falharam",
      rfc: "RFC",
      parameters: "Parâmentro",
      start_datetime: "Data/Hora início",
      end_datetime: "Data/Hora fim",
      execution_log: "Log de Execução",
      get_children: "Buscar Filhos",
      all_items: "Todos os itens",
      partNumber_status: "Status do PartNumber",
      is_obsolete: "Obsoleto?",
      obsolete_items: "Itens Obsoletos",
      filter_by: "Filtrar por:",
      imperfect: "Imperfeitos",
      list_structure: "Estrutura da lista:",
      show_related: "Exibir Relacionados",
      search_bom: "Buscar BOM",
      obsolete_materials: "Materiais Obsoletos",
      items_without_bom_link: "Itens sem vínculo com BOMs.",
      part_number_not_found: "PN não encontrado",
      material_in_use_by_another_pn: "Material em uso por outro PN",
      stock_set_aside_for_use: "Separado para uso",
      stock_leftover: "Sobra no pool",
      substituted_by: "Substituído por {pn}",
      semi_finished_of: "semiacabado de",
      semi_finished_short: "semiacabado",
      customer_forecast: "Forecast do cliente",
      calculation_order: "ordem de cálculo {n}",
      net_demand: "Demanda líquida",
      lent_row_label: "levou para",
      lent_out_of_total: "Fora do total",
      lent_consumed_as_alternative: "consumido como alternativa",
      subtotal_label: "Subtotal",
      total_demand: "Demanda total",
      total_in_stock: "Total em estoque",
      total_in_transit_label: "Total em trânsito",
      committed_qty: "{qty} comprometidos",
      available_qty: "{qty} disponíveis",
      backlog_previous_week_hint: "falta da semana anterior",
      lent_to_bom: "{pn} levou {qty} para a {bom}",
      lent_not_in_total: "Emprestado não entra no total",
      net_demand_per_bom: "Demanda líquida por BOM",
      backlog_previous_week: "Backlog da semana anterior",
      committed: "Comprometido",
      what_is_being_used: "O que está sendo usado",
      analysis_filter_label: "Análise",
      results_based_on_analysis: "Resultados baseados na análise:",
      analysis_description_template:
        "Análise do Forecast de {{date}}, com projeção de {{period}} semanas e {{boms}} BOMs.",
      materials_analysis_description_template:
        "Resultados gerados a partir da análise {{id}}, cliente {{customer}}, Forecast {{date}}, projeção de {{period}} semanas e {{boms}} BOMs.",
      view_analysis: "Ver análise",
      help: "Ajuda",
      user_manual: "Manual do Usuário",
      technical_documentation: "Documentação técnica",
      technical_documentation_error: "Erro ao abrir a documentação técnica. Tente novamente.",
      technical_documentation_popup_blocked:
        "O navegador bloqueou a nova aba. Clique para abrir a",
      help_lead:
        "Este manual descreve, do ponto de vista do usuário final, como operar o sistema PlanMat — incluindo o acesso, os módulos do menu, os principais fluxos de trabalho e perguntas frequentes.",
      help_summary: "Sumário",
      wait_for_analysis_completion: "Aguarde a conclusão da análise",

      help_table_term: "Termo",
      help_table_meaning: "Significado",
      help_table_environment: "Ambiente",
      help_table_url: "URL",
      help_table_item: "Item",
      help_table_icon: "Ícone",
      help_table_route: "Rota",
      help_table_function: "Função",

      help_s1_title: "1. Introdução",
      help_s1_1_title: "1.1 O que é o PlanMat",
      help_s1_1_p1:
        "O PlanMat (Plan-Mat) é um sistema de planejamento de materiais voltado para ambientes de manufatura. Ele permite:",
      help_s1_1_li1: "Gerenciar a estrutura de produtos (BOM — Bill of Materials).",
      help_s1_1_li2:
        "Manter cadastros de clientes, estoque, ordens de compra e forecast de demanda.",
      help_s1_1_li3:
        "Executar análises de disponibilidade (GDS) que cruzam forecast, estoque atual, itens em trânsito e BOM para projetar o inventário ao longo do tempo.",
      help_s1_1_li4: "Importar dados de planilhas ou diretamente do SAP.",
      help_s1_1_li5:
        "Exportar os resultados das análises em planilhas Excel para distribuir aos times de compras e produção.",
      help_s1_2_title: "1.2 Para quem é este sistema",
      help_s1_2_li1:
        "<strong>Planejadores de materiais</strong> — operam o dia a dia: rodam análises, conferem demandas, ajustam parâmetros.",
      help_s1_2_li2:
        "<strong>Compradores</strong> — consomem os resultados para acionar fornecedores.",
      help_s1_2_li3: "<strong>Gestores</strong> — acompanham via dashboard.",
      help_s1_2_li4:
        "<strong>Administradores</strong> — criam usuários, grupos e definem permissões.",
      help_s1_3_title: "1.3 Glossário rápido",
      help_s1_3_term1: "BOM",
      help_s1_3_def1: "Bill of Materials — lista de componentes que formam um produto final.",
      help_s1_3_term2: "GDS",
      help_s1_3_def2: "Cálculo de disponibilidade que projeta estoque vs. demanda no tempo.",
      help_s1_3_term3: "Forecast",
      help_s1_3_def3: "Previsão de demanda por cliente / componente / data.",
      help_s1_3_term4: "Phantom",
      help_s1_3_def4:
        'Componente "fantasma" da BOM — não tem estoque próprio, é resolvido pelos filhos.',
      help_s1_3_term5: "Item alternativo",
      help_s1_3_def5: "Componente que pode substituir outro na mesma posição da BOM.",
      help_s1_3_term6: "PO",
      help_s1_3_def6: "Purchase Order — ordem de compra com itens em trânsito.",
      help_s1_3_term7: "On hand",
      help_s1_3_def7: "Quantidade fisicamente em estoque hoje.",
      help_s1_3_term8: "In transit",
      help_s1_3_def8: "Quantidade já comprada mas ainda não recebida.",
      help_s1_3_term9: "Projected inventory",
      help_s1_3_def9: "Estoque projetado para uma data futura (saldo após demanda e chegadas).",

      help_s2_title: "2. Acesso ao sistema",
      help_s2_1_title: "2.1 URL de acesso",
      help_s2_1_env1: "Desenvolvimento",
      help_s2_1_url1: "http://10.0.2.125/",
      help_s2_1_env2: "Homologação",
      help_s2_1_url2: "https://planmat.fpf.br",
      help_s2_1_env3: "Produção",
      help_s2_1_url3: "https://singapura.fxnbr.com",
      help_s2_1_env4: "Local (devs)",
      help_s2_1_url4: "http://localhost:3000",
      help_s2_2_title: "2.2 Login",
      help_s2_2_step1: "Acesse a URL do ambiente desejado.",
      help_s2_2_step2: "Preencha <strong>Usuário</strong> e <strong>Senha</strong>.",
      help_s2_2_step3:
        "Use o seletor <strong>PT / EN</strong> no rodapé do card de login caso deseje trocar o idioma da interface.",
      help_s2_2_step4: "Clique em <strong>Entrar</strong>.",
      help_s2_2_note:
        "Em caso de erro de credenciais, o sistema exibe uma mensagem abaixo do botão <strong>Entrar</strong>. Esqueceu a senha? Solicite a um administrador a redefinição pelo módulo <em>Controle de acesso → Usuários</em>.",
      help_s2_2_alt: "Tela de login",
      help_s2_2_caption: "Tela de login do PlanMat.",
      help_s2_3_title: "2.3 Tela inicial (Home)",
      help_s2_3_p1:
        "Após o login, o usuário é direcionado para a tela inicial. O layout padrão tem:",
      help_s2_3_li1:
        "<strong>Barra lateral (sidebar)</strong> à esquerda, com o menu de navegação.",
      help_s2_3_li2:
        "<strong>Barra superior</strong> com indicador do usuário logado, troca de idioma e logout.",
      help_s2_3_li3: "<strong>Área central</strong> com o conteúdo da página atual.",
      help_s2_3_alt: "Tela inicial",
      help_s2_3_caption: "Tela inicial após o login.",

      help_s3_title: "3. Menu lateral",
      help_s3_p1: "O menu lateral é dividido em dois grupos principais:",
      help_s3_alt: "Menu lateral",
      help_s3_caption: "Barra lateral expandida com os dois grupos.",
      help_s3_1_title: "3.1 Controle de acesso",
      help_s3_1_item1: "Grupos",
      help_s3_1_icon1: "Groups",
      help_s3_1_route1: "/account/group",
      help_s3_1_func1: "Define perfis e permissões de acesso.",
      help_s3_1_item2: "Usuários",
      help_s3_1_icon2: "Person",
      help_s3_1_route2: "/account/user",
      help_s3_1_func2: "Cadastra e gerencia os usuários do sistema.",
      help_s3_2_title: "3.2 Geral",
      help_s3_2_item1: "Análise",
      help_s3_2_icon1: "AutoGraph",
      help_s3_2_route1: "/general/analysis",
      help_s3_2_func1: "Cria, processa e consulta as análises GDS.",
      help_s3_2_item2: "BOM",
      help_s3_2_icon2: "DeviceHub",
      help_s3_2_route2: "/general/bom",
      help_s3_2_func2: "Cadastra a estrutura de produtos.",
      help_s3_2_item3: "Cliente",
      help_s3_2_icon3: "Person",
      help_s3_2_route3: "/general/customer",
      help_s3_2_func3: "Cadastra os clientes.",
      help_s3_2_item4: "Estoque",
      help_s3_2_icon4: "Warehouse",
      help_s3_2_route4: "/general/stock",
      help_s3_2_func4: "Consulta o estoque atual.",
      help_s3_2_item5: "Forecast",
      help_s3_2_icon5: "CalendarMonth",
      help_s3_2_route5: "/general/forecast",
      help_s3_2_func5: "Gerencia as previsões de demanda.",
      help_s3_2_item6: "Ordem de Compra",
      help_s3_2_icon6: "ShoppingCart",
      help_s3_2_route6: "/general/po",
      help_s3_2_func6: "Consulta e gerencia POs.",
      help_s3_2_item7: "Importar Dados",
      help_s3_2_icon7: "UploadFile",
      help_s3_2_route7: "/general/import-data",
      help_s3_2_func7: "Importa dados de planilhas ou SAP.",
      help_s3_2_item8: "Dashboard",
      help_s3_2_icon8: "Widgets",
      help_s3_2_route8: "/general/dashboard",
      help_s3_2_func8: "Painéis de acompanhamento.",
      help_s3_2_item9: "Demandas de Material",
      help_s3_2_icon9: "Inventory2",
      help_s3_2_route9: "/general/materials-demands",
      help_s3_2_func9: "Consolidado das demandas.",
      help_s3_2_item10: "Ajuda",
      help_s3_2_icon10: "HelpOutline",
      help_s3_2_route10: "/general/help",
      help_s3_2_func10: "Este manual do usuário.",

      help_s4_title: "4. Controle de acesso",
      help_s4_1_title: "4.1 Usuários — /account/user",
      help_s4_1_p1:
        "Mostra a lista de usuários cadastrados, com filtros e busca. As colunas típicas são <em>Login, Nome, E-mail, Grupo, Status</em> (ativo/inativo) e ações (editar/desativar).",
      help_s4_1_alt1: "Lista de usuários",
      help_s4_1_caption1: "Lista de usuários cadastrados.",
      help_s4_1_p2: "Para criar ou editar:",
      help_s4_1_step1:
        "Clique em <strong>Novo usuário</strong> ou dê duplo clique sobre a linha do usuário a editar.",
      help_s4_1_step2:
        "Preencha <em>Login, Nome, E-mail, Senha</em> (na criação) e selecione o <em>Grupo de permissões</em>.",
      help_s4_1_step3: "Salve.",
      help_s4_1_alt2: "Formulário de usuário",
      help_s4_1_caption2: "Formulário de criação/edição de usuário.",
      help_s4_1_note:
        "<strong>Reset de senha:</strong> não existe self-service de troca de senha. Quando o usuário esquecer a senha, o administrador entra na edição do usuário (duplo clique na linha) e redefine para a senha padrão <code>123456</code>, que o usuário deve trocar no próximo acesso. Apenas usuários com permissão de administrador veem este módulo.",
      help_s4_2_title: "4.2 Grupos — /account/group",
      help_s4_2_p1:
        "Mostra os grupos (perfis) existentes e quantos usuários cada um possui. Permite nomear o grupo e marcar quais itens de menu / funcionalidades ele pode acessar.",
      help_s4_2_alt1: "Lista de grupos",
      help_s4_2_caption1: "Lista de grupos de permissão.",
      help_s4_2_alt2: "Formulário de grupo",
      help_s4_2_caption2: "Edição de grupo com seleção de menus permitidos.",

      help_s5_title: "5. Cadastros básicos",
      help_s5_1_title: "5.1 Clientes — /general/customer",
      help_s5_1_p1: "Cadastro simples de clientes que servirão de referência para o forecast.",
      help_s5_1_li1: "<strong>Listar:</strong> veja os clientes existentes, filtre por nome.",
      help_s5_1_li2:
        "<strong>Novo cliente:</strong> botão <em>Novo</em> abre o formulário, normalmente com o campo <em>Nome</em> (o sistema também aceita o cliente padrão <em>Dados SAP</em> para forecast vindo do ERP).",
      help_s5_1_li3: "<strong>Editar / inativar:</strong> ações na própria linha da lista.",
      help_s5_1_alt: "Lista de clientes",
      help_s5_1_caption: "Listagem de clientes cadastrados.",
      help_s5_2_title: "5.2 BOM — /general/bom",
      help_s5_2_p1: "Cadastra a estrutura de cada produto final.",
      help_s5_2_step1: "Acesse <strong>BOM</strong> no menu.",
      help_s5_2_step2: "Clique em <strong>Nova BOM</strong> para criar uma nova estrutura.",
      help_s5_2_step3:
        "Selecione o <em>Produto final</em> (componente marcado como <code>is_final_product</code>).",
      help_s5_2_step4:
        "Adicione as linhas de componentes: <em>Componente (part number), Quantidade necessária, Item (número de agrupamento), Grupo, Prioridade de uso</em> (<code>PRIMARY</code> ou <code>ALTERNATIVE</code>) e <em>Phantom</em>.",
      help_s5_2_alt1: "Lista de BOMs",
      help_s5_2_caption1: "Listagem de BOMs cadastradas.",
      help_s5_2_alt2: "Edição de BOM",
      help_s5_2_caption2: "Tela de edição de BOM com componentes.",
      help_s5_2_note:
        'Componentes marcados como <strong>Phantom</strong> não geram demanda própria — sua demanda é "explodida" para os filhos da BOM.',
      help_s5_3_title: "5.3 Estoque — /general/stock",
      help_s5_3_p1:
        "Tela de consulta do estoque atual (<em>on hand</em>) por componente. Geralmente os dados aqui chegam via importação (SAP ou planilha) e não são editados manualmente.",
      help_s5_3_alt: "Estoque",
      help_s5_3_caption: "Consulta de estoque atual.",

      help_s6_title: "6. Forecast — /general/forecast",
      help_s6_1_title: "6.1 Listar previsões",
      help_s6_1_p1:
        "A tela inicial do módulo mostra as previsões existentes, agrupadas por cliente e versão (cada nova importação cria uma versão nova).",
      help_s6_1_alt: "Lista de forecasts",
      help_s6_1_caption: "Lista de forecasts por cliente e versão.",
      help_s6_2_title: "6.2 Detalhar uma previsão",
      help_s6_2_p1:
        "Clicando em uma previsão, o usuário vê os componentes previstos com quantidade e data de entrega.",
      help_s6_2_alt: "Detalhe de forecast",
      help_s6_2_caption: "Detalhe de uma previsão.",
      help_s6_3_title: "6.3 Importação automática (SAP)",
      help_s6_3_note:
        "Toda segunda-feira às 09:00, o sistema importa automaticamente o forecast do SAP (planta 451N por padrão), cria uma nova versão e dispara as análises configuradas. Não é necessária nenhuma ação do usuário.",
      help_s6_3_p1:
        "Para forçar uma importação manual, acesse <em>Importar Dados → SAP</em> (ver Seção 8).",

      help_s7_title: "7. Ordens de Compra (PO) — /general/po",
      help_s7_p1:
        "Mostra as POs registradas no sistema com seus componentes em trânsito. Cada linha de PO traz: número da PO, fornecedor, componente, quantidade pedida e convertida, previsão de entrega (ETD) e unidade.",
      help_s7_alt: "Lista de POs",
      help_s7_caption: "Lista de ordens de compra com itens em trânsito.",
      help_s7_note:
        "A quantidade em trânsito dos cálculos de análise vem destas POs (somatório das quantidades pendentes com ETD dentro da janela analisada).",

      help_s8_title: "8. Importar dados — /general/import-data",
      help_s8_p1:
        "A tela principal lista os tipos de importação suportados e o status das últimas execuções.",
      help_s8_alt: "Importar dados",
      help_s8_caption: "Hub de importação de dados.",
      help_s8_1_title: "8.1 Importação via planilha — /general/import-spreadsheets",
      help_s8_1_step1: "Selecione o tipo de dado (Forecast, Estoque, BOM, PO, etc.).",
      help_s8_1_step2: "Baixe o template da planilha se for sua primeira vez.",
      help_s8_1_step3:
        "Preencha a planilha e arraste o arquivo <code>.xlsx</code> para a área de upload (ou clique em <em>Selecionar arquivo</em>).",
      help_s8_1_step4: "Clique em <strong>Importar</strong>.",
      help_s8_1_step5:
        "Acompanhe o status — em caso de erro, baixe o relatório de erros gerado pelo sistema.",
      help_s8_1_alt: "Importação via planilha",
      help_s8_1_caption: "Tela de importação via planilha.",
      help_s8_2_title: "8.2 Importação via SAP — /general/import-sap",
      help_s8_2_step1:
        "Verifique se o ambiente está com <code>SAP_ENABLED=true</code> (configurado pelo administrador).",
      help_s8_2_step2: "Selecione o tipo (<em>Forecast, Estoque</em>, etc.).",
      help_s8_2_step3:
        'Informe <em>Planta</em> e <em>Materiais</em> (ou deixe em branco para "todos").',
      help_s8_2_step4: "Clique em <strong>Importar do SAP</strong>.",
      help_s8_2_step5:
        "O sistema aciona o worker <code>imports_worker</code> (com VPN) e mostra o progresso.",
      help_s8_2_alt: "Importação via SAP",
      help_s8_2_caption: "Tela de importação via SAP.",
      help_s8_2_note:
        "Falhas na conexão VPN/SAP aparecem como erro nesta tela. Avise o time de infraestrutura informando o ID da execução.",

      help_s9_title: "9. Análise (GDS) — /general/analysis",
      help_s9_p1: "Este é o fluxo principal do sistema.",
      help_s9_1_title: "9.1 Listar análises",
      help_s9_1_p1:
        "A tela inicial do módulo mostra todas as análises (calculadas e pendentes), com nome, período (<code>start_date → end_date</code>), status e ações.",
      help_s9_1_alt: "Lista de análises",
      help_s9_1_caption: "Listagem de análises.",
      help_s9_1_note:
        "<strong>Excluir análises:</strong> marque uma ou mais linhas usando as caixas de seleção da primeira coluna e clique em <em>Deletar</em> para remover definitivamente. A deleção é múltipla por padrão — selecione todas as análises que deseja apagar antes de confirmar.",
      help_s9_2_title: "9.2 Criar uma nova análise",
      help_s9_2_step1: "Clique em <strong>Nova análise</strong>.",
      help_s9_2_step2:
        "Preencha o <em>Nome da análise</em> (sugestão: data + cliente, ex.: <code>2026-05_FPF</code>), <em>Data inicial</em> e <em>Data final</em> do horizonte, e os <em>Forecasts considerados</em> (um ou mais — multi-seleção).",
      help_s9_2_step3:
        "Clique em <strong>Salvar</strong>. A análise entra na fila para processamento.",
      help_s9_2_alt: "Nova análise",
      help_s9_2_caption: "Formulário de criação de análise.",
      help_s9_3_title: "9.3 Acompanhar o processamento",
      help_s9_3_p1:
        "Mostra em tempo real o progresso do cálculo. Comunicação por WebSocket, atualizando barra de progresso, etapa atual (carregando BOMs, calculando demanda, gerando resultados, exportando) e estimativa de conclusão.",
      help_s9_3_alt: "Processamento de análise",
      help_s9_3_caption: "Tela de processamento em tempo real.",
      help_s9_4_title: "9.4 Tela de erros",
      help_s9_4_p1:
        'Quando o cálculo falha, mostra a causa e os componentes/POs/forecasts que provocaram o erro, com sugestão de correção (ex.: "BOM não encontrada para o produto X").',
      help_s9_4_alt: "Erros de análise",
      help_s9_4_caption: "Tela de detalhamento de erros.",
      help_s9_5_title: "9.5 Cálculo GDS",
      help_s9_5_p1: "Após o processamento, mostra para cada componente:",
      help_s9_5_li1: "Estoque inicial (<code>on_hand</code>)",
      help_s9_5_li2: "Demanda projetada (do forecast)",
      help_s9_5_li3: "Quantidades em trânsito (das POs)",
      help_s9_5_li4: "Estoque projetado por data (<code>projected_inventory</code>)",
      help_s9_5_li5: "Status (suficiente / risco / faltante)",
      help_s9_5_alt: "Cálculo GDS",
      help_s9_5_caption: "Tela de cálculo GDS por componente.",
      help_s9_6_title: "9.6 Simulação GDS",
      help_s9_6_p1:
        "Permite alterar parâmetros (quantidade em estoque, chegada antecipada de PO, troca por item alternativo, etc.) e ver o impacto no estoque projetado <strong>sem persistir a alteração</strong>.",
      help_s9_6_alt: "Simulação GDS",
      help_s9_6_caption: "Tela de simulação GDS.",
      help_s9_7_title: "9.7 Exportar resultado",
      help_s9_7_p1:
        "A partir da tela de cálculo, clique em <strong>Exportar</strong> (canto superior direito) para gerar o resultado em Excel. A geração é assíncrona: o sistema dispara um worker e o arquivo fica disponível para download assim que pronto. O arquivo é armazenado no servidor por um período configurável e pode ser baixado novamente pelo histórico.",

      help_s10_title: "10. Demandas de Material — /general/materials-demands",
      help_s10_p1:
        'Consolida em uma única tela a demanda total de componentes para um determinado intervalo, somando todas as análises ativas. Útil para compras consultar rapidamente "o que precisa ser comprado".',
      help_s10_p2: "Recursos típicos:",
      help_s10_li1: "Filtro por período e componente.",
      help_s10_li2: "Exportação para Excel.",
      help_s10_li3:
        "Drill-down: ao clicar no componente, vê quais análises contribuem para a demanda.",
      help_s10_alt: "Demandas de Material",
      help_s10_caption: "Tela de Demandas de Material.",

      help_s11_title: "11. Dashboard — /general/dashboard",
      help_s11_p1: "Painel de acompanhamento gerencial com:",
      help_s11_li1: "<strong>Cards de KPI no topo:</strong>",
      help_s11_li2: "<em>Cobertura Crítica</em> — itens com até 4 semanas de cobertura.",
      help_s11_li3: "<em>Cobertura de Atenção</em> — itens com cobertura entre 5 e 8 semanas.",
      help_s11_li4: "<em>Excesso de materiais</em> — itens com excesso após cobertura total.",
      help_s11_li5: "<em>Materiais Obsoletos</em> — itens sem vínculo com BOMs.",
      help_s11_li6:
        "<strong>Previsão contínua e detecção de outliers (IC 95%)</strong> — área principal. Use o filtro <em>Filtrar por</em> (Part Number / Modelo) e selecione um valor para que o gráfico de previsão seja exibido.",
      help_s11_li7:
        "<strong>Cards laterais:</strong> previsão de longo prazo, desvios/anomalias e tendência geral da demanda.",
      help_s11_alt: "Dashboard",
      help_s11_caption: "Painel de acompanhamento gerencial.",

      help_s12_title: "12. Perguntas frequentes (FAQ)",
      help_s12_q1: "Q: Por que minha análise demora muito?",
      help_s12_a1:
        "Análises com muitos componentes e janelas longas levam mais tempo. O sistema usa workers Celery dedicados (<code>analysis-worker-1</code> e <code>analysis-worker-2</code>) que processam uma análise por vez por worker. Se houver fila, a sua análise aguarda a anterior terminar.",
      help_s12_q2: "Q: Importei a planilha mas alguns componentes não aparecem.",
      help_s12_a2:
        "Componentes inativos (<code>active=false</code>) não entram nas análises. Verifique também se o <code>part_number</code> da planilha existe exatamente como cadastrado.",
      help_s12_q3: 'Q: A importação do SAP travou em "VPN".',
      help_s12_a3:
        "A VPN é necessária para acessar a rede do SAP. Se a credencial VPN expirou ou o TOTP está fora de sincronia, a importação falha. Contate o time de infraestrutura.",
      help_s12_q4: 'Q: O que é um "componente phantom"?',
      help_s12_a4:
        'Phantom é um componente da BOM que não tem estoque próprio. Quando a análise encontra um phantom, ela "explode" a demanda para os componentes-filhos.',
      help_s12_q5: "Q: Posso reabrir uma análise antiga?",
      help_s12_a5:
        "Sim. Toda análise fica gravada com seu resultado (<code>AnalysisResult</code>). Acesse <em>Análise</em>, clique no nome e use <em>Ver cálculo</em> ou <em>Exportar</em> novamente.",
      help_s12_q6: "Q: Como apago uma análise que não preciso mais?",
      help_s12_a6:
        "Na lista de <em>Análise</em>, marque a(s) linha(s) usando a caixa de seleção da primeira coluna e clique em <em>Deletar</em>. A operação aceita seleção múltipla.",
      help_s12_q7: "Q: Como mudo a senha?",
      help_s12_a7:
        "Não existe troca de senha por conta própria. Peça a um administrador editar seu usuário em <em>Controle de acesso → Usuários</em> (duplo clique na linha) e redefinir para a senha padrão <code>123456</code>. Troque a senha após o primeiro login.",

      help_s13_title: "13. Suporte",
      help_s13_li1: "<strong>Canal de atendimento:</strong> a definir (e-mail / chat).",
      help_s13_li2: "<strong>SLA de resposta:</strong> a definir.",
      help_s13_li3:
        "<strong>Como abrir um chamado:</strong> descrever passo a passo do erro, ambiente (dev/homolog/prod), nome do usuário, ID da análise/importação e anexar print da tela.",

      bom_models: "BOM (Modelos)",
      select_bom_to_view_components:
        "Selecione uma BOM acima para visualizar e editar os componentes.",
      not_informed: "Não informado",
      add_substitute: "→ adicionar substituto",
      successfully_added_substitute: "Substituto adicionado com sucesso",
      successfully_updated_substitute: "Substituto atualizado com sucesso",
      substitution_already_exists: "Este componente já possui um substituto cadastrado.",
      invalid_substitution_data: "Dados inválidos para adicionar o substituto.",
      substitute: "Substituto",
      new_part_number: "Novo Part Number",
      starting_from: "a partir de",
      search_part_number_description_substitute: "Part Number, descrição, substituto",
      substitute_quantity_must_be_positive: "Quantidade precisa ser maior que zero",
      reset_simulation: "Resetar simulação",
      reset_simulation_confirm_message:
        "Tem certeza que deseja remover todos os substitutos e os PNs adicionados manualmente deste modelo de BOM?",
      successfully_reset_simulation: "Simulação resetada com sucesso",
      add_above: "Adicionar acima",
      add_below: "Adicionar abaixo",
      add_subitem: "Adicionar subitem",
      exclude: "Excluir",
      deactivate: "Desativar",
      activate: "Ativar",
      manually_added: "Adicionado manualmente",
      new_pn_part_number: "Part Number do novo item",
      invalid_addition_data: "Dados inválidos para adicionar o novo PN.",
      part_number_required: "Informe o Part Number.",
      successfully_added_pn: "Novo PN adicionado com sucesso",
      successfully_updated_pn: "PN atualizado com sucesso",
      successfully_deleted_pn: "PN removido com sucesso",
      successfully_toggled_pn: "Situação do PN atualizada com sucesso",
      delete_pn_confirm_title: "Excluir PN adicionado",
      delete_pn_confirm_message:
        "Tem certeza que deseja excluir este PN adicionado manualmente? Para mantê-lo na estrutura sem considerá-lo no cálculo, use 'Desativar'.",
      sap_import_health: "Saúde das importações SAP",
      sap_import_health_subtitle: "Acompanhe o resultado da última execução das cargas utilizadas no planejamento.",
      sap_import_health_load_error: "Não foi possível carregar a saúde das importações SAP.",
      price_per_pn: "Preço por PN",
      last_execution: "Última execução",
      view_details: "Ver detalhes",
      no_execution_recorded: "Nenhuma execução registrada",
      import_started_at: "Iniciada em",
      not_available: "Não disponível",
      in_progress_label: "Em andamento",
      try_again: "Tentar novamente",
      import_status_healthy: "Saudável",
      import_status_critical: "Crítico",
      import_status_processing: "Processando",
      import_status_not_run: "Sem execução",
      import_result_success: "Carga concluída com sucesso.",
      import_result_error: "A última carga terminou com erro.",
      import_result_processing: "Carga em processamento.",
      import_result_not_run: "Nenhuma execução foi registrada.",
      materialStatus: {
        tabs: {
          gds: "Resultado GDS",
          demands: "Itens e Demanda",
          materialStatus: "Material Status",
          waitForCompletionTooltip: "Aguarde a conclusão da análise para acessar esta aba.",
          notGeneratedTooltip:
            "Esta análise ainda não possui Material Status gerado. Conclua o GDS e clique em Gerar Material Status.",
          loadingAnalysis: "Carregando análise...",
        },
        loading: {
          gds: "Carregando resultado GDS",
          demands: "Carregando itens e demanda",
          grid: "Carregando grade",
        },
        kpi: {
          pnInFilter: "P/N no filtro",
          redBeacon: "Farol vermelho",
          withShortage: "Com ruptura no horizonte",
          closestShortage: "Ruptura mais próxima",
          redBeaconUnavailable: "Indisponível: o PlanMat não tem farol (RAG)",
        },
        controls: {
          searchPlaceholder: "P/N ou componente limitante",
          searchAriaLabel: "Buscar Part Number...",
          onlyShortage: "Só com ruptura",
          onlyShortageAriaLabel: "Apenas com ruptura",
          exportXlsx: "Exportar Excel",
          exporting: "Exportando...",
          waiting: "Aguardando...",
          exportError: "Não foi possível exportar o Material Status. Tente novamente.",
          exportExpired: "A exportação expirou. Gere o arquivo novamente.",
          horizon: "Horizonte",
          weeksOption: "{{count}} sem",
          collapseAll: "Recolher tudo",
          expandAll: "Expandir tudo",
          fullscreen: "Tela cheia",
          exitFullscreen: "Sair da tela cheia",
          fullscreenEnterTooltip: "Ver só a grade, em tela cheia",
          fullscreenExitTooltip: "Sair da tela cheia (Esc)",
        },
        legend: {
          summaryTitle: "Legenda das cores e como o cálculo funciona",
          dsiCriticalLabel: "Crítico",
          dsiCriticalDesc: "DSI abaixo de 5 dias",
          dsiShortLabel: "Curto",
          dsiShortDesc: "DSI de 5 a 9 dias",
          dsiAdequateLabel: "Adequado",
          dsiAdequateDesc: "DSI de 10 a 15 dias",
          dsiComfortableLabel: "Confortável",
          dsiComfortableDesc: "DSI acima de 15 dias",
          noteTotalSupplyTitle: "Suprimento total",
          noteTotalSupplyBody: "soma Produto acabado / WIP e Material em estoque na semana em que foram registrados. Material em trânsito, ETA e",
          notePoPendingEmp: "PO aguardando confirmação do ODM",
          notePoPendingRest: "ainda não têm fonte no PlanMat.",
          noteProjectedStockTitle: "Estoque projetado",
          noteProjectedStockBody:
            "começa em zero na semana da data-base; a cada semana parte do saldo anterior, desconta o forecast líquido e soma o suprimento disponível na própria semana.",
          noteDsiTitle: "DSI",
          noteDsiBody:
            "divide o estoque projetado pela demanda média diária das 4 semanas seguintes (20 dias úteis), arredondando para longe de zero. Sem demanda nessas semanas, fica vazio.",
          sourceSap: "Origem: snapshot congelado da análise (Forecast líquido, Produto acabado / WIP e Material em estoque)",
        },
        grid: {
          partNumber: "PN ({{count}})",
          limitingComponent: "Componente\nlimitante",
          priority: "Prioridade",
          pnPerPage: "P/N por página",
          pageRange: "{{start}} – {{end}} de {{total}}",
          fromSnapshot: "do snapshot congelado",
          unavailable: "sem dado no PlanMat",
          calculated: "calculado",
          shortageFrom: "Ruptura a partir de {{week}}",
          noShortage: "Sem ruptura no horizonte",
          openTrace: "Memória de cálculo: {{row}}, {{pn}}, {{week}}",
          openOnHand: "Material On Hands: {{pn}}, {{week}}",
        },
        descriptions: {
          forecastNet:
            "Quanto o cliente vai consumir em cada semana. Vem pronto do módulo de Forecast e não se edita aqui. É a demanda que puxa o estoque para baixo.",
          forecastFlex:
            "A mesma demanda, mas somada à folga contratada com o cliente e ao estoque de segurança. Sempre maior que o forecast líquido - é o cenário pessimista, usado só na segunda linha de projeção.",
          finishGoods:
            "Placas já montadas ou em processo de montagem na fábrica. Material que existe fisicamente e não depende de mais ninguém. Vem do módulo de Estoque.",
          onHands:
            "Material no almoxarifado da fábrica, já contado. Assim como o produto acabado, existe fisicamente - é a base do cálculo na semana da data-base. Vem do módulo de Estoque, e existe só na semana da data-base: é uma contagem, não um valor que se repete toda semana. O saldo semana a semana está na linha de estoque projetado.",
          inTransit:
            "Já embarcou e está a caminho, no navio ou no avião. Ainda não chegou, mas saiu da origem - por isso conta como suprimento quase certo. Vem das ordens de compra já embarcadas, agrupadas pela semana de chegada.",
          eta: "Ainda não embarcou. O ODM confirmou a data de saída (ETD), e a partir dela se calcula a semana de chegada (ETA). É um compromisso do fornecedor, não um material em movimento. Vem das ordens de compra com ETD confirmado, somadas por semana de chegada quando há mais de um embarque na mesma semana; a cor da célula mostra a situação do lote.",
          poPending:
            "Pedido colocado, mas o ODM ainda não confirmou data nenhuma. Vem das ordens de compra sem ETD confirmado. Atenção: esta linha NÃO entra no suprimento total nem na projeção de estoque - promessa sem confirmação não vira material.",
          total:
            "Produto acabado / WIP mais Material em estoque, na semana em que foram registrados. Material em trânsito, ETA e PO ainda não têm fonte no PlanMat e não entram na soma.",
          projNet:
            "O saldo de estoque semana a semana: o saldo anterior, menos a demanda da semana, mais o material que ficou disponível. Quando fica negativo, há ruptura - falta material para atender o cliente.",
          projFlex:
            "O mesmo saldo, mas descontando a demanda com flexibilidade e estoque de segurança. Rompe antes da projeção pelo forecast líquido - serve de alerta antecipado.",
          dsi: "Days Sales Inventory: quantos dias de produção o estoque cobre, olhando a demanda das 4 semanas seguintes. Negativo significa que já falta material; baixo e positivo significa cobertura curta.",
        },
        trace: {
          title: "Memória de cálculo",
          loading: "Carregando memória de cálculo",
          error: "Não foi possível carregar a memória de cálculo desta célula.",
          close: "Fechar",
          projectionTitle: "Estoque projetado",
          previousBalance: "Saldo anterior ({{week}})",
          baselineStart: "Data-base: o saldo começa em 0",
          demand: "− Forecast líquido da semana",
          finishedGoods: "+ Produto acabado / WIP",
          materialOnHand: "+ Material em estoque",
          totalSupply: "= Suprimento total da semana",
          projected: "Estoque projetado ({{week}})",
          shortageOf: "Ruptura de {{quantity}} kits",
          dsiTitle: "DSI",
          windowWeek: "Forecast líquido {{week}}",
          windowTotal: "Demanda das 4 semanas seguintes",
          dailyAverage: "Média diária (÷ {{days}} dias úteis)",
          rawValue: "Estoque projetado ÷ média diária",
          dsiValue: "DSI (arredondado para longe de zero)",
          partialWindow: "Fim do horizonte: a janela só tem as semanas que existem.",
          noFutureDemand: "Sem demanda futura: o DSI não é calculado.",
          beforeBaseline: "Semana anterior à data-base: não é calculada.",
          range: {
            critical: "Crítico",
            short: "Curto",
            adequate: "Adequado",
            comfortable: "Confortável",
          },
          shortageTitle: "Ruptura e recuperação",
          firstShortage: "Primeira ruptura",
          noShortage: "Sem ruptura no horizonte",
          recovery: "Recuperação",
          recoveryIn: "{{week}} (em {{count}} semanas)",
          noRecovery: "Sem recuperação no horizonte",
          limitingComponent: "Material em estoque / componente limitante",
        },
        onHand: {
          title: "Material On Hands - {{pn}}",
          summaryKits: "{{kits}} kits a produzir",
          summaryStock: "{{kits}} kits em estoque",
          summaryScenario: "por forecast líquido",
          summaryStockBasis: "por estoque físico no almoxarifado",
          tableSectionTitle: "Part numbers em falta nesta semana",
          tableSectionTitleStock: "Componentes da BOM e cobertura de estoque",
          noShortage: "Nenhum part number em falta nesta semana.",
          partNumberCol: "Part number",
          usageCol: "Uso",
          requiredCol: "Necessário",
          availableCol: "Disponível",
          missingCol: "Falta",
          coverageCol: "Cobertura",
          limitingBadge: "Limitante",
          footerCoverage: "Cobertura de",
          footerKitsMissing: "kits - faltam",
          footerRestrictedBy: ", restritos por",
          footerKitsStock: "kits em estoque",
          footerRestrictedByStock: ", restrita por",
          footerAllCoverPrefix: "Todos os componentes cobrem os",
          footerAllCoverSuffix: "kits.",
          footerShortage: "Cobertura de {{- coverage}} kits - faltam {{- missing}}, restritos por {{limiting}}.",
          footerStockOnly: "Cobertura de {{- coverage}} kits em estoque, restrita por {{limiting}}.",
          footerNoShortage: "Todos os componentes cobrem os {{- kits}} kits.",
          noBreakdown: "Os detalhes dos componentes não estão disponíveis para esta geração do Material Status.",
          loading: "Carregando detalhamento de Material On Hands...",
          error: "Não foi possível carregar o detalhamento de Material On Hands desta célula.",
          closeAriaLabel: "Fechar",
        },
        empty: "Nenhum Part Number encontrado para os filtros selecionados.",
        loadError: "Não foi possível carregar os dados de Material Status desta análise.",
      },
    },
  },
};

export { messages };
